import React from 'react';
import { notification, Modal } from 'antd/lib';
import { graphql, compose, withApollo } from 'react-apollo';
import Loading from '../../../common/Loading';

import getTodosTiposSellos from '../../../../graphql/querys/otros/getTodosTiposSellos.graphql';
import deleteTipoSello from '../../../../graphql/mutations/otros/deleteTipoSello.graphql';
import getOrganismos from '../../../../graphql/querys/organismos/getOrganismos.graphql';
import recibirArregloLimites from '../../../../graphql/mutations/otros/recibirArregloLimites.graphql';

import TablaTipoSellos from './TablaTipoSellos';
import { errorService } from '../../../../graphql/utils/utils';

@compose(
  graphql(getTodosTiposSellos, { options: { fetchPolicy: 'network-only' } }),
  graphql(deleteTipoSello, {
    name: 'deleteTipoSello',
    options: {
      refetchQueries: [{ query: getTodosTiposSellos }],
    },
  }),
  graphql(recibirArregloLimites, {
    name: 'recibirArregloLimites',
    options: {
      refetchQueries: [{ query: getTodosTiposSellos }],
    },
  }),
  graphql(getOrganismos, {
    name: 'organismos',
  })
)
class VerTiposSellos extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      filtro: '',
    };

    this.onDelete = this.onDelete.bind(this);
  }

  onDelete(id) {
    //TODO: Hacer el onDelete.

    this.props
      .deleteTipoSello({
        variables: { _id: id },
      })
      // eslint-disable-next-line no-unused-vars
      .then(res => {
        notification.success({
          message: 'Tipo Sello eliminado',
          description: 'Se ha eliminado correctamente el tipo sello',
        });
      })
      .catch(err => {
        console.log('Existio un error a la hora de eliminar el tipo sello');
        console.log(err);
        errorService(err, {
          _id: id,
        });
        Modal.error({
          title: 'Error en lrecibirArregloLimitesthcion del tipo de tasa',
          content:
            'Lamentamos inforecibirArregloLimitesthe la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      });
  }

  enviarDatos = (_id, valores) => {
    console.log('RECIBO: ');
    console.log(_id);
    console.log(valores);

    let pares = [];

    /* _.forEach(valores, elem => {
      console.log('ELEMENTO: ', elem);
      pares.push({ idOrganismo: Object.keys(elem), limite: elem });
    }); */

    Object.keys(valores).forEach(function eachKey(key) {
      pares.push({ idOrganismo: key, limite: valores[key] });
    });

    console.log('El formato de los pares es:');
    console.log(pares);

    this.props
      .recibirArregloLimites({
        variables: { _id, arreglo: pares },
      })
      .then(res => {
        console.log('la respuesta que recibi es ....');
        console.log(res);
      })
      .catch(err => {
        console.log('ERROR EN EL RECIBIR ARREGLO');
        console.log(err);
        errorService(err, {
          _id,
          arreglo: pares,
        });
      });
  };

  render() {
    if (this.state.loading) {
      return <Loading />;
    }

    let listaTiposSellos = this.props.data.getTodosTiposSellos;
    if (!listaTiposSellos) {
      listaTiposSellos = [];
    }

    return (
      <div>
        <TablaTipoSellos
          tiposSellos={listaTiposSellos}
          organismos={this.props.organismos.getOrganismos}
          enviarDatos={this.enviarDatos}
          history={this.props.history}
        />
      </div>
    );
  }
}

export default withApollo(VerTiposSellos);
